import styled from 'styled-components';
import { Form } from 'antd';

const { Item } = Form;

export const CustomFormInputs = styled(Item)<{ fontSize?: string }>`
	height: 2.25rem;

	label {
		font-weight: bold;
		font-size: ${({ fontSize }) => fontSize ?? ''};
	}

	@media (min-width: 1200px) {
		height: 3rem;
	}

	.ant-form-item-explain-error {
		position: absolute;
		white-space: nowrap;
	}

	.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional) {
		&::before {
			display: none;
		}
	}
`;
